<app-navbar></app-navbar>

<div class="min-h-screen bg-section pt-24 pb-20 px-4 sm:px-6 lg:px-8 font-serif text-body-text selection:bg-btn/30 relative overflow-hidden">
  
  <div class="max-w-4xl mx-auto relative z-10 space-y-16">
    
    <!-- Hero Section -->
    <div class="text-center space-y-6 animate-fade-in">
      <h1 class="text-4xl sm:text-5xl font-serif text-heading tracking-tight">Website Legal Policies</h1>
      <div class="w-24 h-px bg-btn mx-auto opacity-50"></div>
      <p class="text-lg text-muted italic leading-relaxed max-w-2xl mx-auto">
        AARVYA / Nisarga Foods
      </p>
    </div>

    <!-- Content Sections -->
    <div class="bg-white p-6 sm:p-12 border border-[#E5DDD5] rounded-sm shadow-sm animate-fade-in-up space-y-12">
      
      <!-- Terms & Conditions -->
      <section class="space-y-4">
        <h2 class="text-2xl font-serif text-heading border-b border-[#E5DDD5] pb-2">Terms & Conditions</h2>
        <div class="space-y-4 text-body-text leading-relaxed opacity-90">
          <p>
            Welcome to the AARVYA website operated by Nisarga Foods. By accessing or using this website you agree to comply with these Terms & Conditions.
          </p>
          <p>
            All products sold on this website are natural wellness products intended for general nutritional support. We strive to ensure that all product information, descriptions, and pricing are accurate; however, errors may occur and we reserve the right to correct them without prior notice.
          </p>
          <p>
            Nisarga Foods reserves the right to refuse or cancel any order due to stock limitations, pricing errors, or compliance requirements. Use of this website and any disputes arising from it shall be governed by the laws of India.
          </p>
          
          <h3 class="text-lg font-serif text-heading mt-6">Intellectual Property</h3>
          <p>
            All content on this website including logos, brand names, product images, text, and design elements are the intellectual property of Nisarga Foods. Unauthorized reproduction, copying, or distribution of any content without written permission is prohibited.
          </p>
        </div>
      </section>

      <!-- Privacy Policy -->
      <section class="space-y-4">
        <h2 class="text-2xl font-serif text-heading border-b border-[#E5DDD5] pb-2">Privacy Policy</h2>
        <div class="space-y-4 text-body-text leading-relaxed opacity-90">
          <p>
            Nisarga Foods respects your privacy and is committed to protecting your personal information. This policy explains how we collect, use, and safeguard the information you provide when interacting with the AARVYA website.
          </p>
          
          <h3 class="text-lg font-serif text-heading mt-6">Information We Collect</h3>
          <ul class="list-disc pl-5 space-y-1">
            <li>Name and contact information such as email and phone number</li>
            <li>Shipping and billing address</li>
            <li>Order and transaction details</li>
            <li>Website browsing information and device data</li>
          </ul>

          <h3 class="text-lg font-serif text-heading mt-6">How We Use Your Information</h3>
          <ul class="list-disc pl-5 space-y-1">
            <li>Processing and delivering orders</li>
            <li>Providing customer support</li>
            <li>Sending order confirmations and updates</li>
            <li>Improving website performance and services</li>
          </ul>

          <h3 class="text-lg font-serif text-heading mt-6">Payment Security</h3>
          <p>
            Payments are processed through secure third-party payment gateways. Nisarga Foods does not store credit or debit card details.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Data Protection</h3>
          <p>
            We implement reasonable security practices to protect personal information from unauthorized access or misuse. However, no online platform can guarantee complete security.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Third-Party Services</h3>
          <p>
            Our website may use trusted third-party services such as logistics providers, analytics tools, and payment processors. These providers may collect limited information according to their own privacy policies.
          </p>
        </div>
      </section>

      <!-- Shipping Policy -->
      <section class="space-y-4">
        <h2 class="text-2xl font-serif text-heading border-b border-[#E5DDD5] pb-2">Shipping Policy</h2>
        <div class="space-y-4 text-body-text leading-relaxed opacity-90">
          <p>
            Orders are generally processed within 1–3 business days after payment confirmation. Delivery timelines may vary depending on the destination and courier partner availability.
          </p>
          
          <h3 class="text-lg font-serif text-heading mt-6">Estimated Delivery Time</h3>
          <ul class="list-disc pl-5 space-y-1">
            <li>Metro cities: approximately 3–5 business days</li>
            <li>Other locations: approximately 5–8 business days</li>
          </ul>

          <h3 class="text-lg font-serif text-heading mt-6">Shipping Disclaimer</h3>
          <p>
            Nisarga Foods is not responsible for delays caused by courier services, logistics disruptions, weather conditions, or other circumstances beyond our control.
          </p>
        </div>
      </section>

      <!-- Return & Refund Policy -->
      <section class="space-y-4">
        <h2 class="text-2xl font-serif text-heading border-b border-[#E5DDD5] pb-2">Return & Refund Policy</h2>
        <div class="space-y-4 text-body-text leading-relaxed opacity-90">
          <p>
            Due to the nature of consumable products, returns are generally not accepted once the product has been delivered. However, replacements or refunds may be provided in specific situations.
          </p>
          
          <h3 class="text-lg font-serif text-heading mt-6">Eligible Cases</h3>
          <ul class="list-disc pl-5 space-y-1">
            <li>Product received damaged</li>
            <li>Incorrect product delivered</li>
            <li>Package tampered during delivery</li>
          </ul>

          <h3 class="text-lg font-serif text-heading mt-6">Reporting Issues</h3>
          <p>
            Customers must report any issue within 48 hours of delivery with the order number and supporting photos or videos.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Refund Processing</h3>
          <p>
            Approved refunds will be issued to the original payment method. Processing time may vary depending on the payment provider.
          </p>
        </div>
      </section>

      <!-- Product & Health Disclaimer -->
      <section class="space-y-4">
        <h2 class="text-2xl font-serif text-heading border-b border-[#E5DDD5] pb-2">Product & Health Disclaimer</h2>
        <div class="space-y-4 text-body-text leading-relaxed opacity-90">
          <p>
            The information provided on this website is for general informational purposes only and should not be interpreted as medical advice. AARVYA products are natural wellness products and are not intended to diagnose, treat, cure, or prevent any disease.
          </p>
          <p>
            Statements regarding herbal ingredients may be based on traditional Ayurvedic knowledge and publicly available nutritional references.
          </p>
          
          <h3 class="text-lg font-serif text-heading mt-6">Nutritional Information Disclaimer</h3>
          <p>
            Nutritional values displayed for products are approximate and indicative in nature. Natural variations may occur due to agricultural conditions, sourcing differences, and processing methods.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Usage Advisory</h3>
          <p>
            Individuals who are pregnant, nursing, taking medication, or suffering from medical conditions should consult a qualified healthcare professional before consuming herbal products.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Limitation of Liability</h3>
          <p>
            Nisarga Foods shall not be held liable for misuse of products, allergic reactions, or health outcomes resulting from improper usage of products purchased through this website.
          </p>

          <h3 class="text-lg font-serif text-heading mt-6">Governing Law</h3>
          <p>
            These policies and any disputes arising from the use of this website shall be governed by the laws of India.
          </p>
        </div>
      </section>

    </div>
  </div>
</div>
